// removed by extract-text-webpack-plugin
module.exports = {"agMainPanel":"_27Rf4UXNjXzom3chH-Wu8e","pushedleft":"_3LxI-ODuImuKh8_vnX2Pdx","onePanel":"_2YrUVdSv396l_QLugB-Jbn","semiPushedleft":"_1QeEwY_jpxQ8VGbJcyqn5W","visibleleft":"_2-qh96vwgWPG_hrVazg_o5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MainPanel/MainPanel.scss
// module id = 822
// module chunks = 0